import React from 'react';
import { TableCell, TableHead, TableRow, withStyles } from "@material-ui/core";
import clsx from 'clsx'

const styles = theme => ({
  head: {
    zIndex: '290',
    position: "sticky",
    top: 0,
    backgroundColor: "#ffffff",
    height: '43px',
    whiteSpace: 'nowrap',
    minWidth: '41px'
  },
  cell: {
    textAlign: 'center',
    borderTop: '1px solid rgba(224, 224, 224, 1)'
  },
  sideBorders: {
    borderRight: '1px solid rgba(224, 224, 224, 1)',
  },
  weekend: {
    backgroundColor: '#ffe4c4'
  },
  name: {
    padding: '0 75px',
    textAlign: 'center'
  },
  pattern: {
    padding: '0 25px',
    textAlign: 'center'
  },
  errorStatus: {
    padding: '0px'
  },
  transparent: {
    color: 'transparent',
    backgroundColor: 'transparent'
  }
});

function createDaysTableCell(variableColumnsHeader, classes, fixedClass) {
  let tableCells = [];
  if (typeof variableColumnsHeader !== 'undefined') {
    variableColumnsHeader.forEach((col) => {
      tableCells.push(<TableCell
        key={col}
        align='center'
        className={clsx(classes.head, classes.cell, fixedClass, classes.sideBorders)}
      >
        {col}
      </TableCell>);
    })
  }
  return tableCells;
}

function createDataviewColumnsTableCell(dataviewColumns, classes, fixedClass, fixed = false) {
  const tableCells = [];
  if (typeof dataviewColumns !== 'undefined') {
    dataviewColumns.forEach((column, index) => {
      if (column.show) {
        tableCells.push(<TableCell key={column.value + index} className={clsx(classes.head, classes.cell, fixedClass, (!fixed) ? 'dataview-column' : '', classes.sideBorders)}>{column.value}</TableCell>)
      }
    });
  }
  return tableCells;
}

function TableHeader(props) {

  const { classes, dataviewColumnsHeader, variableColumnsHeader, fixed, position, showRight = false } = props;
  let fixedClass = "";

  if (fixed) {
    if (position === 'left') {
      return (
        <TableHead>
          <TableRow>
            {createDataviewColumnsTableCell(dataviewColumnsHeader, classes, fixedClass, true)}
          </TableRow>
        </TableHead>
      )
    }
    else {
      let rightContent = showRight ? (
        <TableHead>
          <TableRow>
            <TableCell className={[classes.head, classes.cell]} >Year total</TableCell>
            <TableCell className={[classes.head, classes.cell]} >Day</TableCell>
            <TableCell className={[classes.head, classes.cell]} >Eve</TableCell>
            <TableCell className={[classes.head, classes.cell]} >Night</TableCell>
          </TableRow>
        </TableHead>
      ) :
        '';
      return rightContent
    }
  }
  else {
    // let rightContent = showRight ? ([
    //   <TableCell className={['fixedRight', classes.head, classes.cell, fixedClass]} >Year total</TableCell>,
    //   <TableCell className={['fixedRight', classes.head, classes.cell, fixedClass]} >Day</TableCell>,
    //   <TableCell className={['fixedRight', classes.head, classes.cell, fixedClass]} >Eve</TableCell>,
    //   <TableCell className={['fixedRight', classes.head, classes.cell, fixedClass]} >Night</TableCell>]
    // ) :
    //   ''
    return (
      <TableHead>
        <TableRow>
          {createDataviewColumnsTableCell(dataviewColumnsHeader, classes, fixedClass)}
          {createDaysTableCell(variableColumnsHeader, classes, fixedClass)}
          {/* {rightContent} */}
        </TableRow>
      </TableHead>
    );
  }
}

export default withStyles(styles)(TableHeader);